import { AxiosRequestConfig } from "axios";
import axios from "http/customAxios"
import dayjs from "dayjs";
import qs from "qs";


type BodyTrivagoType = {
  api_version: string;
  hotels: string;
  start_date: string;
  end_date: string;
  room_adults_1: number;
  num_rooms: string;
  lang: string;
  rate_model: string;
  currency: string;
  room_childs_1?: number[];
};

type CustomDataPropertyARIType = {
  [key: string]: {
    ticker: string;
    name: string;
    price: number;
    averageRate: number;
    originalRate: number;
    rackRate: number;
    cityTax: number;
  };
};

type ItemResultJsonType = {
  type: string;
  expectedValue?: number;
  givenValue?: number;
  value?: string;
};

type ResultJsonType = {
  [key: string]: {
    gha: {
      discrepancies: ItemResultJsonType[];
    };
    tripadvisor: {
      discrepancies: ItemResultJsonType[];
    };
    trivago: {
      discrepancies: ItemResultJsonType[];
    };
  };
};

type InitialResultJsonType = {
  propertyTicker: string;
  results: ResultJsonType;
};

const config: AxiosRequestConfig = {
  method: "post",
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/x-www-form-urlencoded",
  },
};

const getDataTrivago = (URLTRIVAGO: string, body: BodyTrivagoType) => {
  const bodyTrivago = qs.stringify(body);
  return axios({ ...config, data: bodyTrivago, url: URLTRIVAGO });
};

const calcTotalPriceTrivago = (element: any, key: any, nights: any, totalDiscount: any) => {
  return (
    Math.round((element[key].final_rate * nights - totalDiscount + Number.EPSILON) * 100) / 100
  );
};

const priceIsWrong = (ARIprice: number, TrivagoPrice: number, tolerance: number) =>
  Math.abs(ARIprice - TrivagoPrice) > tolerance ? true : false;

export const trivagoCompareToARI = async (
  URL_TRIVAGO: string,
  BODY_TRIVAGO: BodyTrivagoType,
  customPropertyARI: CustomDataPropertyARIType,
  nights: number,
  tolerance: number,
  initialResultJson: InitialResultJsonType,
  nameHasDiscrepancies: string[],
  setNameHasDiscrepancies: Function
) => {
  const dataTrivago = BODY_TRIVAGO;
  const { data } = await getDataTrivago(URL_TRIVAGO, dataTrivago);
  data.root.hotels.forEach((hotel: any) => {
    if (hotel.room_types.length) {
      hotel.room_types.forEach((room_type: any) => {
        room_type.forEach((element: any) => {
          for (const key in element) {
            if (customPropertyARI[element[key].room_code]) {
              let totalDiscount = 0;
              element[key].discounts.forEach((element: any) => {
                totalDiscount += element.final_rate;
              });
              const totalPriceTrivago = calcTotalPriceTrivago(element, key, nights, totalDiscount);
              if (
                priceIsWrong(
                  customPropertyARI[element[key].room_code].price,
                  totalPriceTrivago,
                  tolerance
                )
              ) {
                setNameHasDiscrepancies((prevValue: string[]) => [...prevValue, "trivago"])
                initialResultJson.results[element[key].room_code].trivago.discrepancies.push({
                  type: "PRICE",
                  expectedValue: customPropertyARI[element[key].room_code].price,
                  givenValue: totalPriceTrivago,
                });
              }
            } else {
              initialResultJson?.results?.[element?.[key].room_code]?.trivago?.discrepancies.push({
                type: "PROPERTYARI_NOT_FOUND",
                value: element[key].room_code,
              });
              
            }
          }
        });
      });
    } else {
      initialResultJson.results["not_records"].trivago.discrepancies.push({
        type: "EMPTY",
        value: "Has no records",
      });
    }
  });
  return data;
};

export const runTrivago = async ({
  config,
  customPropertyARI,
  tolerance,
  initialResultJson,
  nameHasDiscrepancies,
  setNameHasDiscrepancies,
  urlTrivago
}: any) => {
  const BODY_TRIVAGO: BodyTrivagoType = {
    api_version: "4",
    hotels: `["${config.propertyTicker}"]`,
    start_date: config.start,
    end_date: config.end,
    room_adults_1: config.adults,
    num_rooms: "1",
    lang: "de_DE", // does not allow global language
    rate_model: "AI",
    currency: config.currency,
  };
  const ages: number[] = [];
  const iterations = config.children + config.teenagers + (config.babies ? config.babies : 0);
  if (iterations > 0) {
    if (config.guestAges) {
      BODY_TRIVAGO.room_childs_1 = config.guestAges;
    } else {
      for (let index = 0; index < iterations; index++) {
        ages.push(10);
      }
      BODY_TRIVAGO.room_childs_1 = ages;
    }
  }
  const date1 = dayjs(config.start);
  const date2 = dayjs(config.end);
  const runBodyTrivago = BODY_TRIVAGO;
  const runResTrivago = await trivagoCompareToARI(
    urlTrivago,
    BODY_TRIVAGO,
    customPropertyARI,
    date2.diff(date1, "day"),
    tolerance,
    initialResultJson,
    nameHasDiscrepancies,
    setNameHasDiscrepancies
  );

  return { runBodyTrivago, runResTrivago };
};